var accordion_item_default = (() => {
    if (customElements.get("accordion-item")) return;
    customElements.define("accordion-item", class AccordionItem extends HTMLElement {
        constructor() {
            super();
            this.trigger = null;
            this.panel = null;
            this.groupName = null;
            this.isOpen = false;
            this.handleClick = this.handleClick.bind(this);
            this.handleKeydown = this.handleKeydown.bind(this);
        }
        connectedCallback() {
            this.trigger = this.querySelector("[data-accordion-trigger]");
            this.panel = this.querySelector("[data-accordion-panel]");
            this.groupName = this.getAttribute("data-group") || null;
            this.isOpen = this.hasAttribute("data-open");
            if (!this.trigger || !this.panel) return;
            this.trigger.addEventListener("click", this.handleClick);
            this.trigger.addEventListener("keydown", this.handleKeydown);
        }
        disconnectedCallback() {
            this.trigger?.removeEventListener("click", this.handleClick);
            this.trigger?.removeEventListener("keydown", this.handleKeydown);
        }
        handleClick() {
            this.isOpen ? this.close() : this.open();
        }
        handleKeydown(e) {
            if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                this.handleClick();
            }
        }
        open() {
            if (this.groupName) document.querySelectorAll(`accordion-item[data-group="${this.groupName}"]`).forEach(sibling => {
                if (sibling !== this && sibling.isOpen) sibling.close();
            });
            this.isOpen = true;
            this.setAttribute("data-open", "");
            this.trigger.setAttribute("aria-expanded", "true");
            this.panel.classList.remove("invisible");
            requestAnimationFrame(() => {
                this.panel.classList.remove("grid-rows-[0fr]", "opacity-0");
                this.panel.classList.add("grid-rows-[1fr]", "opacity-100");
            });
        }
        close() {
            this.isOpen = false;
            this.removeAttribute("data-open");
            this.trigger.setAttribute("aria-expanded", "false");
            this.panel.classList.remove("grid-rows-[1fr]", "opacity-100");
            this.panel.classList.add("grid-rows-[0fr]", "opacity-0");
            let settled = false;
            const finish = () => {
                if (settled) return;
                settled = true;
                this.panel.removeEventListener("transitionend", onTransitionEnd);
                this.panel.classList.add("invisible");
            };
            const onTransitionEnd = e => {
                if (e.propertyName !== "grid-template-rows") return;
                finish();
            };
            this.panel.addEventListener("transitionend", onTransitionEnd);
            setTimeout(finish, 350);
        }
    });
})();